import React, { useContext } from 'react';
import Image from 'next/image';
import { Typography } from '@pw-tech/omni-ui';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { CourseContext } from '@/modules/RegisterLayout/contexts/CoursesContextProvider';
const Pass = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const {
    selectedCourseData
  } = useContext(CourseContext);
  return <>
      <div className="relative p-5 bg-[#F6FEF9] rounded-lg flex gap-2 text-center items-center my-4 shadow-sm">
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/11b0429b-6d1d-4ba4-9832-5afd5e2369f6.svg" alt="college" width={120} height={120} className="absolute bottom-0 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
        <div className="flex flex-col items-center self-center gap-3 mx-auto text-center">
          <div className="flex flex-col items-center self-center gap-3">
            <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/dba27f28-ce72-4052-af99-60710bd839ed.svg" alt="pass-trophy" width={40} height={40} data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
            <Typography variant="regular" className="!text-sm sm:!text-base" data-sentry-element="Typography" data-sentry-source-file="Pass.tsx">
              Congrats, You've Cleared the Fast Track Process Video Interview! 🎉
            </Typography>
            <div className="flex flex-col gap-8">
              <div className="flex self-center">
                <Typography variant="heading1" weight="bold" className="!text-[#099250] !text-4xl w-max h-max" data-sentry-element="Typography" data-sentry-source-file="Pass.tsx">
                  {registrationDetails?.scaledScore ?? '-'}
                  <span className="!text-[#757575] text-xs w-max h-max">
                    /{selectedCourseData?.metaData?.daMaxScore || 60}
                  </span>
                </Typography>
              </div>
              <div className="flex">
                <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/463c8efb-a28b-4967-bcd0-8d4a39551d1b.png" alt="pass" width={200} height={2} className="object-cover w-[100px] h-[2px] sm:!w-[200px]" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
                <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/3f12a6ea-8929-46bd-a426-8d3019d1ed77.png" alt="pass" width={30} height={30} data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
                <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/3f12a6ea-8929-46bd-a426-8d3019d1ed77.png" alt="pass" width={30} height={30} className="rotate-180" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
                <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/463c8efb-a28b-4967-bcd0-8d4a39551d1b.png" alt="pass" width={200} height={2} className="object-cover w-[100px] h-[2px] sm:!w-[200px]" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
              </div>
            </div>
            <Typography variant="heading3" weight="bold" className=" !text-[#099250]" data-sentry-element="Typography" data-sentry-source-file="Pass.tsx">
              You're On the Fast Track to PW IOI!
            </Typography>
            <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="Pass.tsx">
              You're now just a few steps away from joining PW IOI. Please proceed with your
              application.
            </Typography>
          </div>
        </div>
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/11b0429b-6d1d-4ba4-9832-5afd5e2369f6.svg" alt="college" width={120} height={120} className="absolute bottom-0 right-4 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="Pass.tsx" />
      </div>
    </>;
};
export default Pass;